// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"dc6fa862","348":"00e88ee4","571":"b965b5c1","924":"22ea23ce"}[chunkId] + ".chunk.js";
};